import React from 'react';
import { Stack } from '@mui/material';

import { GlobalHistoryButton } from './GlobalHistoryButton.tsx';
import { BaseStepsStatusIndicator } from './BaseStepsStatusIndicator.tsx';
import { ActiveCustomStepsStatusIndicator } from './ActiveCustomStepsStatusIndicator.tsx';

interface SummaryRingsProps extends React.ComponentProps<typeof Stack> {}

export const SummaryRings: React.FC<SummaryRingsProps> = (props) => (
  <Stack direction="row" gap={1} alignItems="center" {...props}>
    <BaseStepsStatusIndicator />
    <ActiveCustomStepsStatusIndicator />
    <GlobalHistoryButton />
  </Stack>
);
